import React from 'react';
import { Cross } from '@saleshandy/icons';
import { accessibleOnClick } from '../../../../shared/utils';

interface DislikeFeedbackPopupProps {
  value: string;
  onChange: (value: string) => void;
  isLoading: boolean;
  onSubmit: (message: string) => void | Promise<void>;
  onClose: () => void;
}

const DislikeFeedbackPopup: React.FC<DislikeFeedbackPopupProps> = ({
  value,
  onChange,
  isLoading,
  onSubmit,
  onClose,
}) => {
  const handleSubmit = async () => {
    await onSubmit(value);
  };

  return (
    <div className="profile-modal__dislike-popup">
      <div className="profile-modal__dislike-popup-header">
        <span className="semibold-3 gray-txt-9">What&apos;s wrong?</span>
        <button
          type="button"
          className="profile-modal__dislike-popup-close"
          aria-label="Close"
          {...accessibleOnClick(onClose)}
        >
          <Cross width={14} height={14} color="#6b7280" />
        </button>
      </div>
      <p className="profile-modal__dislike-popup-desc regular-2 gray-txt-11">
        Tell us what looks off. Our data team reviews every report.
      </p>
      <textarea
        className="profile-modal__dislike-popup-textarea regular-2"
        placeholder="E.g., Wrong email, poor fit, outdated role, incorrect company..."
        maxLength={100}
        rows={4}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <div className="profile-modal__dislike-popup-actions">
        <button
          type="button"
          className="profile-modal__dislike-popup-cancel regular-2"
          {...accessibleOnClick(onClose)}
        >
          Cancel
        </button>
        <button
          type="button"
          className="profile-modal__dislike-popup-submit"
          disabled={isLoading}
          {...accessibleOnClick(handleSubmit)}
        >
          {isLoading ? 'Sending...' : 'Send feedback'}
        </button>
      </div>
    </div>
  );
};

export default DislikeFeedbackPopup;
